import React from 'react'
import { cn } from '../../lib/cn'
import { CopyButton } from './CopyButton'

export interface IdMetaItem {
  label: string
  /** Пустое значение (null, undefined, пустая строка) не рисуется вовсе. */
  value: string | null | undefined
  /** Рисовать рядом CopyButton. */
  copy?: boolean
  /** Значение моноширинным: номера, коды, артикулы. */
  mono?: boolean
  /** Значение — ссылка. */
  href?: string
  /** Значение — кнопка (например, открыть связанное окно). */
  onClick?: () => void
  title?: string
}

export interface IdMetaProps {
  items: IdMetaItem[]
  className?: string
}

const valueClass = (mono?: boolean, interactive?: boolean) =>
  cn(
    'min-w-0 truncate text-gray-700 dark:text-zinc-300',
    mono && 'font-mono',
    interactive && 'text-indigo-700 hover:underline dark:text-indigo-400',
  )

/**
 * IdMeta — строка служебных номеров под заголовком окна.
 *
 * «Кабинет: КСА · Ревизия: #3 · SEO: #11 · v2». Подпись — серым, значение —
 * основным цветом, номера моноширинным, рядом по желанию кнопка копирования.
 */
export const IdMeta: React.FC<IdMetaProps> = ({ items, className }) => {
  const visible = items.filter(
    (item) => item.value !== null && item.value !== undefined && String(item.value).trim() !== '',
  )
  if (visible.length === 0) return null
  return (
    <dl
      className={cn('m-0 flex min-w-0 flex-wrap items-center gap-x-3 gap-y-0.5 text-[11px]', className)}
      aria-label="Служебные номера"
    >
      {visible.map((item) => {
        const value = String(item.value)
        return (
          <div key={item.label} className="flex min-w-0 items-center gap-1" title={item.title}>
            <dt className="shrink-0 text-gray-400 dark:text-zinc-500">{item.label}</dt>
            <dd className="m-0 flex min-w-0 items-center gap-0.5">
              {item.href ? (
                <a href={item.href} className={valueClass(item.mono, true)}>
                  {value}
                </a>
              ) : item.onClick ? (
                <button type="button" onClick={item.onClick} className={valueClass(item.mono, true)}>
                  {value}
                </button>
              ) : (
                <span className={valueClass(item.mono)}>{value}</span>
              )}
              {item.copy && <CopyButton value={value} label={item.label.toLowerCase()} size="xs" />}
            </dd>
          </div>
        )
      })}
    </dl>
  )
}

export default IdMeta
